var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonPageBanner",style:({ background: _vm.url ? 'url(' + _vm.url + ')' : 'url(' + _vm.backUrl + ')' })})
}
var staticRenderFns = []

export { render, staticRenderFns }